import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformMembershipSubscription } from './membership-subscriptions.transformers';
import { MembershipSubscriptionsCollection } from './membership-subscriptions.types';

export function membershipSubscriptionsReducer(
  state: CollectionStateSlice<MembershipSubscriptionsCollection> = {},
  action: CollectionActions<MembershipSubscriptionsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'membershipSubscriptions') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<MembershipSubscriptionsCollection>(
          state,
          transformIntoDocuments(result, transformMembershipSubscription),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
